import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../shared/components/inputs/TextInput';
import { AuthPageLayout } from '../shared/components/containers/AuthPageLayout';
import { Form } from 'react-bootstrap';
import { PrimaryButton } from '../shared/components/buttons/PrimaryButton';
import { BasicAnchor } from '../shared/components/links/BasicAnchor';
import { BrandHeader } from '../shared/components/headers/BrandHeader';
import { ApiError } from '../api/client';
import { requestPasswordReset } from '../api/auth';

interface OwnProps {
}

const StyledTextInput = styled(TextInput)`
  width: 100%;
  max-width: 350px;
  margin-bottom: 20px;
`;

const InFormHeader = styled.div`
  font-weight: 600;
  font-size: 1.3em;
  margin-bottom: 5px;
`;

const HeaderExplanation = styled(Form.Text)`
  margin-bottom: 15px;
  display: flex;
`;

const ButtonRow = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoginRow = styled.div`
  margin-top: 30px;
`;

const ErrorText = styled(Form.Text)`
  color: ${(props) => props.theme.colors.error};
  display: block;
  margin-bottom: 15px;
`;

const ConfirmationText = styled(Form.Text)`
  display: block;
  margin-bottom: 15px;
`;

const ForgotPasswordPage = (props: OwnProps) => {
  const {} = props;
  const { t } = useTranslation();
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmitClick = async () => {
    setError(null);
    setSubmitting(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : t('forgotPassword.errors.failed'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthPageLayout>
      <BrandHeader/>

      <InFormHeader>{t('forgotPassword.heading')}</InFormHeader>

      {sent ? (
        <ConfirmationText>
          {t('forgotPassword.confirmation', { email })}
        </ConfirmationText>
      ) : (
        <>
          <HeaderExplanation muted>
            {t('forgotPassword.explanation')}
          </HeaderExplanation>

          <Form.Label htmlFor="forgot-password-email">{t('forgotPassword.emailLabel')}</Form.Label>
          <StyledTextInput id="forgot-password-email" onChange={setEmail} value={email} type='email'/>

          {error && <ErrorText>{error}</ErrorText>}

          <ButtonRow>
            <PrimaryButton onClick={onSubmitClick} disabled={submitting}>
              {submitting ? t('forgotPassword.submitting') : t('forgotPassword.submit')}
            </PrimaryButton>
          </ButtonRow>
        </>
      )}

      <LoginRow>
        <Form.Text muted>
          <BasicAnchor url='/'>{t('forgotPassword.backToLogin')}</BasicAnchor>
        </Form.Text>
      </LoginRow>
    </AuthPageLayout>
  );
};

export {
  ForgotPasswordPage,
};
